/**
 * Keeps the product-card quick-add form variant id in sync with the selected color swatch
 * (multi-variant products without selling plans use product-form instead of quick-buy modal).
 */
(function () {
  if (window.__degelerProductCardCartSync) return;
  window.__degelerProductCardCartSync = true;

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio') return;
    var card = t.closest && t.closest('product-card');
    if (!card) return;
    var vid = t.getAttribute('data-variant-id');
    if (!vid) return;
    var form = card.querySelector('product-form form[action*="/cart/add"]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = vid;
  });
})();
